import { render, staticRenderFns } from "./big-screen.vue?vue&type=template&id=49b1a635&scoped=true&"
import script from "./big-screen.vue?vue&type=script&lang=js&"
export * from "./big-screen.vue?vue&type=script&lang=js&"
import style0 from "./big-screen.vue?vue&type=style&index=0&id=49b1a635&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1a635",
  null
  
)

export default component.exports